/** Tastele machetei, fără cele bătute într-un câmp.
 *
 *  `OrbitControls.listenToKeyEvents(window)` ia săgețile de oriunde din pagină:
 *  cine își mută cursorul în discuția fațadei sau într-un câmp al panoului
 *  rotea macheta în același timp. Controalele nu se uită unde s-a apăsat, deci
 *  primesc o țintă care le dă numai tastele care nu sunt ale unui câmp de text.
 *  Controalele cheamă doar `addEventListener` / `removeEventListener`. */
export function tasteInAfaraCampurilor(fereastra: Window): HTMLElement {
  const filtre = new Map<EventListenerOrEventListenerObject, EventListener>();
  const tinta = {
    addEventListener(tip: string, f: EventListenerOrEventListenerObject) {
      const g: EventListener = (e) => {
        if (eCamp(e.target)) return;
        if (typeof f === "function") f(e); else f.handleEvent(e);
      };
      filtre.set(f, g);
      fereastra.addEventListener(tip, g);
    },
    removeEventListener(tip: string, f: EventListenerOrEventListenerObject) {
      const g = filtre.get(f);
      if (g) fereastra.removeEventListener(tip, g);
      filtre.delete(f);
    },
  };
  return tinta as unknown as HTMLElement;
}

/** Un câmp în care se scrie: intrare, zonă de text, listă, conținut editabil. */
export function eCamp(t: EventTarget | null): boolean {
  const el = t as HTMLElement | null;
  return !!el && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName ?? ""));
}
